export default __webpack_public_path__ + "static/media/personal-info.eaf5fd9b.svg";